import successImg from "../Img/client-success.png"; // Replace with your image

const ClientSuccessStories = () => {
  return (
    <section className="success-section">
      {/* Left Content */}
      <div className="success-left">
        <h2 className="success-title">Client Success Stories</h2>

        <div className="success-stats">
          {/* Stat 1 */}
          <div className="success-box">
            <h3>500+</h3>
            <h4>Families Empowered</h4>
            <p>
              Successfully assisted families in securing home loans within 30
              days, turning housing dreams into reality across MMR.
            </p>
          </div>

          {/* Stat 2 */}
          <div className="success-box">
            <h3>₹50Cr+</h3>
            <h4>Business Growth Enabled</h4>
            <p>
              Facilitated business loans totaling over ₹50 crores, fueling SME
              expansion and entrepreneurial success.
            </p>
          </div>

          {/* Stat 3 */}
          <div className="success-box">
            <h3>95%</h3>
            <h4>Client Satisfaction</h4>
            <p>
              High satisfaction ratings with strong repeat referrals and glowing
              testimonials from delighted clients.
            </p>
          </div>
        </div>
      </div>

      {/* Right Image */}
      <div className="success-right">
        <img src={successImg} alt="Client Success" />
      </div>
    </section>
  );
};

export default ClientSuccessStories;
